module.exports = __webpack_public_path__ + "img/368x150_Ecopia.61c674e6.jpg";